import { useFeatureFlags } from '@shared/hooks/useFeatureFlag';
import { Navigate, Route, Routes } from 'react-router-dom';

import AuthHandler from './components/AuthHandler';
import LogoutHandler from './components/LogoutHandler';
import About from './pages/about';
import Arbitrations from './pages/arbitrations';
import Articles from './pages/articles';
import AutoCheck from './pages/autocheck';
import BuyingPortal from './pages/buying-portal';
import Checkin from './pages/checkin';
import Checkout from './pages/checkout';
import ContactUs from './pages/contact-us';
import EarlyBidding from './pages/content/bidding';
import BillOfSaleTerms from './pages/content/bill-of-sale-terms';
import FAQ from './pages/content/faq';
import DealerPortal from './pages/dealer-portal';
import Error from './pages/error';
import Health from './pages/health';
import Home from './pages/home';
import LandingPage from './pages/landing-page';
import Location from './pages/location';
import LocationDetails from './pages/location-details';
import MemberDashboard from './pages/member-dashboard';
import MyList from './pages/my-list';
import MyProfile from './pages/my-profile';
import MyTransactions from './pages/my-transactions';
import NotFound from './pages/not-found';
import OptOut from './pages/opt-out';
import Policy from './pages/policy';
import PublicVDP from './pages/public-vdp';
import SavedSearches from './pages/saved-searches';
import Search from './pages/search';
import State from './pages/state';
import BrokerageLanding from './pages/timed-auctions';
import Transportation from './pages/transportation';
import UserNotActivePage from './pages/user-not-active';
import VDP from './pages/vdp';
import VDPPhotoSurvey from './pages/vdp-photo-survey';
import VinSearch from './pages/vin-search';

const Routing = () => {
    const flags = useFeatureFlags();

    return (
        <Routes>
            <Route
                path="/"
                element={flags?.landingPageVersion === 'V2' ? <LandingPage /> : <Home />}
            />
            <Route path="mytransactions" element={<MyTransactions />} />
            <Route path="vehicledetail/:stockNum" element={<VDP />} />
            <Route path="vehicledetail/:stockNum/:exifTag" element={<VDPPhotoSurvey />} />
            {process.env.ENV_NAME !== 'prod' && (
                <Route path="public-vdp/:vehicleId" element={<PublicVDP />} />
            )}
            <Route path="faq" element={<FAQ />} />
            <Route path="about" element={<About />} />
            <Route path="timed-auctions/*" element={<BrokerageLanding />} />
            <Route path="policy" element={<Policy />} />
            <Route path="mylist" element={<MyList />} />
            <Route path="health" element={<Health />} />
            <Route path="location" element={<Location />} />
            <Route path="location/:stateCode/:locationId" element={<LocationDetails />} />
            <Route path="location/:stateCode" element={<State />} />
            <Route path="saved-searches" element={<SavedSearches />} />
            <Route path="search" element={<Search />} />
            <Route path="vin-search" element={<VinSearch />} />
            <Route path="dealer-portal" element={<DealerPortal />} />
            <Route path="dealer-portal/:navItem" element={<DealerPortal />} />
            <Route path="dealer-portal/:navItem/:navSubItem" element={<DealerPortal />} />
            <Route path="dealer-portal/:navItem/:navSubItem/:tabId" element={<DealerPortal />} />
            <Route
                path="dealer-portal/:addVehicles/:navItem/:navSubItem/:tabId"
                element={<DealerPortal />}
            />
            <Route path="arbitration" element={<Arbitrations />} />
            <Route path="checkin" element={<Checkin />} />
            <Route path="autocheck/:vin" element={<AutoCheck />} />
            <Route path="home/logout" element={<LogoutHandler />} />
            <Route path="auth" element={<AuthHandler />} />
            <Route path="opt-out" element={<OptOut />} />
            <Route path="bill-of-sale-terms" element={<BillOfSaleTerms />} />
            <Route path="bidding" element={<EarlyBidding />} />
            <Route path="myprofile" element={<MyProfile />} />
            <Route path="memberdashboard" element={<MemberDashboard />} />
            <Route path="checkout/*" element={<Checkout />} />
            <Route path="checkout-remote/*" element={<Navigate to="/checkout" replace={true} />} />
            <Route path="buying-portal" element={<BuyingPortal />} />
            <Route path="transportation/*" element={<Transportation />} />
            <Route path="articles/*" element={<Articles />} />
            <Route path="500" element={<Error />} />
            <Route path="usernotactive" element={<UserNotActivePage />} />
            <Route path="contact-us" element={<ContactUs />} />
            {/* ELSE */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default Routing;
